import { useEffect, useState } from "react";
import api from "@/lib/api";

// Returns true only once at least one published job exists.
export default function useHasFeaturedJobs() {
  const [has, setHas] = useState(false);
  useEffect(() => {
    let active = true;
    api.get("/jobs/published", { params: { limit: 1 } })
      .then(({ data }) => { if (active) setHas(Array.isArray(data) && data.length > 0); })
      .catch(() => {});
    return () => { active = false; };
  }, []);
  return has;
}
